import { useEffect, useRef, useState } from 'react';

const HOLD_MS = 10000;
export const LIVE_EXIT_MS = 1500;
const indiaDay = value => {
    const date = new Date(value);
    return Number.isFinite(date.getTime()) ? new Date(date.getTime() + 330 * 60000).toISOString().slice(0, 10) : null;
};

// Only rows seen Pending in this Live session may linger after a status change.
export default function useLivePayments(data, enabled) {
    const entries = useRef(new Map());
    const timers = useRef(new Map());
    const [rows, setRows] = useState([]);

    useEffect(() => {
        const clear = id => {
            const timer = timers.current.get(id);
            if (timer) clearTimeout(timer);
            timers.current.delete(id);
        };
        const publish = () => setRows([...entries.current.values()]);
        if (!enabled) {
            timers.current.forEach(clearTimeout);
            timers.current.clear();
            entries.current.clear();
            publish();
            return;
        }
        if (!data) return;
        const pending = (data.recent || []).filter(row => row.status === 'pending');
        const incoming = new Map(pending.map(row => [row._id, row]));
        const updates = new Map([...(data.today?.recent || []), ...(data.summary?.recent || []), ...(data.activity || []), ...(data.recent || [])].map(row => [row._id, row]));
        const day = indiaDay(data.generatedAt);
        for (const [id, previous] of entries.current) {
            if (incoming.has(id)) continue;
            const updated = updates.get(id);
            if (day && indiaDay(previous.createdAt) !== day) {
                clear(id);
                entries.current.delete(id);
            } else if (updated && updated.status !== 'pending') {
                entries.current.set(id, { ...updated, liveExiting: previous.liveExiting || false });
                if (!timers.current.has(id)) {
                    timers.current.set(id, setTimeout(() => {
                        entries.current.set(id, { ...entries.current.get(id), liveExiting: true });
                        publish();
                        timers.current.set(id, setTimeout(() => {
                            timers.current.delete(id);
                            entries.current.delete(id);
                            publish();
                        }, LIVE_EXIT_MS));
                    }, HOLD_MS));
                }
            } else if (!timers.current.has(id)) {
                // A missing row alone is not evidence of a payment status change.
                entries.current.delete(id);
            }
        }
        // Keep changed rows in their existing slots while they fade out.
        const next = new Map(pending.filter(row => !entries.current.has(row._id)).map(row => [row._id, row]));
        for (const [id, previous] of entries.current) next.set(id, incoming.get(id) || previous);
        pending.forEach(row => clear(row._id));
        entries.current = next;
        publish();
    }, [data, enabled]);

    useEffect(() => () => {
        timers.current.forEach(clearTimeout);
        timers.current.clear();
        entries.current.clear();
    }, []);

    return rows;
}
